import {
  CREATE_VARIABLES_FAILED,
  CREATE_VARIABLES_REQUEST,
  CREATE_VARIABLES_SUCCEEDED,
  DELETE_VARIABLES_FAILED,
  DELETE_VARIABLES_REQUEST,
  DELETE_VARIABLES_SUCCEEDED,
  FETCH_VARIABLES_FAILED,
  FETCH_VARIABLES_REQUEST,
  FETCH_VARIABLES_SUCCEEDED,
  INVALIDATE_VARIABLE_MAPPINGS,
  INVALIDATE_VARIABLES,
  UPDATE_VARIABLES_FAILED,
  UPDATE_VARIABLES_REQUEST,
  UPDATE_VARIABLES_SUCCEEDED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const VARIABLES_API_URL = `${apiUrl}/api/2.0/variables`;

/**
 * Fetch Variables
*/
export const fetchVariables = createAction(FETCH_VARIABLES_REQUEST, (request, page, limit = 20) => {
  return {
    request: request,
    page: page,
    limit: limit
  };
})

const fetchVariablesSucceeded = createAction(FETCH_VARIABLES_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const fetchVariablesFailed = createAction(FETCH_VARIABLES_FAILED, (error) => {
  return {
    error: error
  }
})

function* fetchVariablesSaga(action) {
  const { request, page, limit } = action.payload;
  const fetchVariablesAPI = () => {

    const url = buildUrl(VARIABLES_API_URL, {
        path: `/search?page=${page}&limit=${limit}`
      });

      return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchVariablesAPI);
    yield put(fetchVariablesSucceeded(response));
  } catch (error) {
    yield put(fetchVariablesFailed(error));
  }
}

/**
 * Create Variable
*/

export const createVariable = createAction(CREATE_VARIABLES_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

const createVariableSucceeded = createAction(CREATE_VARIABLES_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const createVariableFailed = createAction(CREATE_VARIABLES_FAILED, (error) => {
  return {
    error: error
  }
})

function* createVariableSaga(action) {
  const { request, callback } = action.payload;
  const createVariableAPI = () => {

      const url = VARIABLES_API_URL

      return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createVariableAPI);
    if (response) {
      if (callback) {
        callback(response);
      }
      yield put(createVariableSucceeded(response));
    }    
  } catch (error) {
    yield put(createVariableFailed(error));
  }
}


/**
 * Update Variable
*/

export const updateVariable = createAction(UPDATE_VARIABLES_REQUEST, (request, editorSession, callback) => {
  return {
    request: request,
    editorSession: editorSession,
    callback:callback
  };
})

const updateVariableSucceeded = createAction(UPDATE_VARIABLES_SUCCEEDED, (response, editorSession) => {
  return {
    response: response,
    editorSession: editorSession
  }
});

const updateVariableFailed = createAction(UPDATE_VARIABLES_FAILED, (error) => {
  return {
    error: error
  }
})

function* updateVariableSaga(action) {
  const { request, editorSession, callback } = action.payload;
  const updateVariableAPI = () => {

      const url = VARIABLES_API_URL

      return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateVariableAPI);
    yield put(updateVariableSucceeded(response, editorSession));
    if(callback){
      callback()
    }
    callback();
  } catch (error) {
    yield put(updateVariableFailed(error));
  }
}


/**
 * Delete Variable
*/

export const deleteVariable = createAction(DELETE_VARIABLES_REQUEST, (id, pageId, editorSession, callback) => {
  return {
    id: id,
    pageId: pageId,
    editorSession: editorSession,
    callback: callback
  };
})

const deleteVariableSucceeded = createAction(DELETE_VARIABLES_SUCCEEDED, (response, pageId, editorSession) => {
  return {
    response: response,
    pageId: pageId,
    editorSession: editorSession
  }
});

const deleteVariableFailed = createAction(DELETE_VARIABLES_FAILED, (error) => {
  return {
    error: error
  }
})

function* deleteVariableSaga(action) {
  const { id, pageId, editorSession, callback } = action.payload;
  const deleteVariableAPI = () => {
      let url = buildUrl(VARIABLES_API_URL, {
        path: id
      });

      return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteVariableAPI);
    yield put(deleteVariableSucceeded(response, pageId, editorSession));
    if(callback){
      callback();
    }
  } catch (error) {
    yield put(deleteVariableFailed(error));
  }
}

export const invalidateVariableMappings = createAction(INVALIDATE_VARIABLE_MAPPINGS);
export const invalidateVariables = createAction(INVALIDATE_VARIABLES);



export default function* variableSaga() {
  yield takeEvery(FETCH_VARIABLES_REQUEST, fetchVariablesSaga);
  yield takeEvery(CREATE_VARIABLES_REQUEST, createVariableSaga);
  yield takeEvery(UPDATE_VARIABLES_REQUEST, updateVariableSaga);
  yield takeEvery(DELETE_VARIABLES_REQUEST, deleteVariableSaga);
}